import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class GlobalSearchService {
    constructor() {
        this.search = new BehaviorSubject([]);
    }
    addOrEditSearch(search) {
        if (this.search
            .getValue()
            .filter(storage => storage.name == search.name && storage.module == search.module).length > 0) {
            this.search.next([
                ...this.search
                    .getValue()
                    .filter(storage => storage.name != search.name && storage.module == search.module),
                Object.assign({}, search)
            ]);
        }
        else {
            this.search.next([...this.search.getValue(), Object.assign({}, search)]);
        }
    }
    removeSearch(search) {
        this.search.next([
            ...this.search
                .getValue()
                .filter(storage => storage.name != search.name && storage.module == search.module)
        ]);
    }
    cleanModuleSearch(module) {
        this.search.next([
            ...this.search.getValue().filter(search => search.module != module)
        ]);
    }
    cleanGlobalSearch() {
        this.search.next([]);
    }
    listenGlobalSearch() {
        return this.search;
    }
}
GlobalSearchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GlobalSearchService_Factory() { return new GlobalSearchService(); }, token: GlobalSearchService, providedIn: "root" });
